import React, { FC } from 'react';
import { Button, Col, Row, Typography } from 'components';
import { DeleteIcon, EditIcon } from 'components/common/icons';
import { SpecialPricingRulesAddUpdateModal } from 'feature/clientTabs/payments/specialPricingRules/addEdit';
import { useSpecialPricingRule } from 'feature/clientTabs/payments/specialPricingRules/specialPricingRule/useSpecialPricingRule';
import styles from './styles.module.scss';
import { PERMISSIONS } from 'constants/permissions';
import { HasAccess } from 'components/common/accessControl';

const { Text } = Typography;

interface ISpecialPricingRule {
  data: Record<string, any>;
  onDeleteModalOpen: (id: string) => void;
}

export const SpecialPricingRule: FC<ISpecialPricingRule> = React.memo((props) => {
  const { data, onDeleteModalOpen } = props;
  const {
    id,
    defaultSupplier,
    defaultPricingReferenceSupplier,
    mainSupplier,
    pricingReferenceSupplier,
    discount,
    markup,
    brand,
  } = data;
  const { editModalState, onEditModalStateChange } = useSpecialPricingRule();
  return (
    <>
      <Row gutter={[0, 12]} className={styles.special_pricing_rule}>
        <Col span={24}>
          <Row justify={'space-between'} align={'middle'} gutter={[16, 0]} wrap={false}>
            <Col span={18}>
              <Text style={{ fontWeight: 600 }} type={'secondary'} title={brand.name} className={styles.name}>
                {brand.name}
              </Text>
            </Col>
            <Col>
              <Row wrap={false}>
                <HasAccess role={PERMISSIONS.clients.payment_special_pricing_rules.delete}>
                  <Button size={'small'} type={'text'} onClick={() => onDeleteModalOpen(id)} icon={<DeleteIcon />} />
                </HasAccess>
                <HasAccess role={PERMISSIONS.clients.payment_special_pricing_rules.write}>
                  <Button size={'small'} type={'text'} onClick={onEditModalStateChange} icon={<EditIcon />} />
                </HasAccess>
              </Row>
            </Col>
          </Row>
        </Col>
        <Col span={24}>
          <Row gutter={[0, 2]}>
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col>
                  <Text type={'secondary'}>Margin</Text>
                </Col>
                <Col>
                  <Text type={'secondary'}>{markup !== null ? `${markup}%` : 'Not Set'}</Text>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col>
                  <Text type={'secondary'}>Discount</Text>
                </Col>
                <Col>
                  <Text type={'secondary'}>{discount !== null ? `${discount}%` : 'Not Set'}</Text>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col>
                  <Text type={'secondary'}>Pricing Reference Supplier</Text>
                </Col>
                <Col>
                  <Text type={'secondary'}>
                    {defaultPricingReferenceSupplier
                      ? 'Default for the Brand'
                      : (pricingReferenceSupplier?.name ?? 'Not Set')}
                  </Text>
                </Col>
              </Row>
            </Col>
            <Col span={24}>
              <Row justify={'space-between'}>
                <Col>
                  <Text type={'secondary'}>Main Supplier</Text>
                </Col>
                <Col>
                  <Text type={'secondary'}>
                    {defaultSupplier ? 'Default for the Brand' : (mainSupplier?.name ?? 'Not Set')}
                  </Text>
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <SpecialPricingRulesAddUpdateModal
        modalState={editModalState}
        onModalStateChange={onEditModalStateChange}
        dataToEdit={data}
      />
    </>
  );
});
